import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Star } from 'lucide-react';

interface AverageRatingProps {
  listingId: string;
  className?: string;
}

export function AverageRating({ listingId, className = "" }: AverageRatingProps) {
  const { data } = useQuery({
    queryKey: ['listingRating', listingId],
    queryFn: async () => {
      // Get guest_to_host reviews for this listing
      const { data, error } = await supabase
        .from('reviews')
        .select(`
          rating,
          bookings!inner(listing_id)
        `)
        .eq('review_type', 'guest_to_host')
        .eq('bookings.listing_id', listingId);

      if (error) throw error;

      const ratings = data.map(r => r.rating);
      const count = ratings.length;
      const average = count > 0 ? ratings.reduce((a, b) => a + b, 0) / count : 0;

      return { average, count };
    },
  });

  if (!data || data.count === 0) {
    return (
      <div className={`flex items-center text-sm text-muted-foreground ${className}`}>
        <Star className="h-4 w-4 mr-1" />
        <span>Ingen anmeldelser</span>
      </div>
    );
  }

  return (
    <div className={`flex items-center text-sm ${className}`}>
      <Star className="h-4 w-4 fill-warning text-warning mr-1" />
      <span className="font-medium">{data.average.toFixed(1)}</span>
      <span className="text-muted-foreground ml-1">({data.count})</span>
    </div>
  );
}